import type { EdgeId } from '@ipfabric/utils';
import classNames from 'classnames';
import { Button } from 'components/Button/Button';
import type { FC, MouseEvent } from 'react';

export interface PacketDetailCloseEvent {
  detailId: EdgeId;
}

interface Props {
  detailId: EdgeId;
  onPathLookupDetailClose?: (event: PacketDetailCloseEvent) => void;
}

export const PacketDetailCloseButton: FC<Props> = (props) => {
  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    props.onPathLookupDetailClose?.({ detailId: props.detailId });
  };

  return (
    <Button
      variant='tertiary'
      size='xxs'
      className={classNames(
        'device-view-packet-detail__close',
        'shrink-0',
        'ml-lgu-3',
      )}
      icon='fa-xmark'
      onClick={handleButtonClick}
      type='button'
    />
  );
};
